import axios from 'axios';
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const authRequest = () => {
  return {
    type: AUTH_REQUEST,
  };
};

export const authSuccess = (data) => {
  return {
    type: AUTH_SUCCESS,
    auth: data,
  };
};

export const authFail = () => {
  return {
    type: AUTH_FAIL,
  };
};

export const authManager = () => {
  return (dispatch) => {
    // dispatch(authRequest());
    return axios
      .get('/api/auth/getData')
      .then((response) => {
        dispatch(authSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(authFail());
        console.log(error);
      });
  };
};

export const auths = (state = { status: 'WAITING', auth: [] }, action) => {
  switch (action.type) {
    case 'AUTH_REQUEST':
      return {
        ...state,
        status: 'WAITING',
      };
    case 'AUTH_SUCCESS':
      return {
        auth: [...action.auth],
        status: 'SUCCESS',
      };
    case 'AUTH_FAIL':
      return {
        status: 'FAIL',
        auth: [],
      };
    default:
      return state;
  }
};
